/// <reference path='../../core/directives/AutocompleterField.ts'/>
'use strict';
namespace Attractions {
    const KEY_ENTER = 13;
    class AttractionsSearch extends Autocompleter.AutocompleterField {

        private selectAttrFn: (item: any) => void;
        public areaOverride: string = 'attractions';
        public selectedData: any;
        public searchId: string;

        constructor (
            public $scope: any,
            public $element: JQuery,
            public $parse: ng.IParseService,
            public $route: ng.route.IRouteService,
            public autocompleter: any,
            public resourceService: Core.ResourceService,
            public attractionService: any,
            public $location: ng.ILocationService,
            public $q: ng.IQService
        ) {
            super();

            // Watch for initial value
            const unwatchInit = this.$scope.$watch('ac.currentValue', item => {
                if (item && item.Title) {
                    this.prefix = item.Title;
                    unwatchInit();
                }
            });

            // Wrap `select` attribute fn
            this.selectAttrFn = this.select;
            this.select = (item) => {
                this.selectAttrFn({item: item});
                this.selectItem(item);
            };

            $scope.$on('fieldOptionSelected', (e, data) => {
                this.selectedData = data;
            });
        }

        search(): void {
            if (this.selectedData) {
                this.attractionService.trackAttractionSearch(
                    this.searchId,
                    this.selectedData.Id,
                    this.selectedData.Title
                );
                this.selectedData.Route ? this.$location.url(this.selectedData.Route) : this.showError(null);
            } else {
                if (this.inputField && this.inputField.val().length) {
                    this.automaticSearch();
                } else {
                    this.showError(null);
                }
            }
        }

        automaticSearch(): void {
            if (this.selectedData)  {
                this.search();
            } else {
                this.fetch().then(res => {
                    this.update(res);
                    if (this.data) {
                        this.selectedData = this.data[0];
                        this.search();
                    } else {
                        this.showError(null);
                    }
                });
            }
        }

        update (result: any): void {
            let options = result.data.Results;

            if (this.selectedData) {
                /// On update reset previously selected data.
                this.selectedData = null;
            }

            if (options.length) {
                this.searchId = result.data.SearchId;
                this.data = options.map((item:any) => {
                    return {
                        Title: item.Name,
                        Id: item.Id,
                        Value: item.Value,
                        Route: item.Route
                    };
                });
            } else {
                this.data = null;
                //this.$scope.$emit('flash:error', this.resourceService.get('NOMATCHES'));
            }
        }

        selectItem (item: any): void {
            if (item && item.Title) {
                this.prefix = item.Title;
            }
        }

        showError(e): void {
            this.$scope.$emit('flash:error', this.resourceService.get('NOATTRACTIONURL'));
        }
    }

    angular
        .module('TR')
        .directive('attractionsSearch', (): ng.IDirective => {
            return <ng.IDirective>{
                restrict: 'E',
                replace: true,
                scope: {},
                controllerAs: 'ac',
                bindToController: {
                    placeholder: '@',
                    select: '&',
                    deselect: '&',
                    currentValue: '=',
                    areaOverride: '@',
                    focusTracker: '=',
                    minPrefix: '@',
                    notActive: '@'
                },
                templateUrl: 'partials/home/directivetemplate?type=AttractionsAutocompleter',
                controller: AttractionsSearch,
                transclude: true,
                compile: (el: any, attrs: any, transclude: any) => {
                    return $scope => {
                        transclude($scope, clone => {
                            el.append(clone);
                            $scope.ac.inputField = el.find('input');
                            $scope.ac.inputField.on('keyup', e => {
                                if(KEY_ENTER === e.keyCode && $scope.ac.inputField.val().length > 2) {
                                    $scope.ac.automaticSearch();
                                } else {
                                    $scope.ac.selectedData = null;
                                }
                            });
                        });
                    };
                }
            };
        });
}
